export default __webpack_public_path__ + "static/media/HAT1567_tn.92af335c.jpg";